import {ActionTree} from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import DataVariable from "../ts/DataVariableInterface";

import * as moment from 'moment';
import DataVariableInterface from "../ts/DataVariableInterface";

export const actions: ActionTree<any, any> = {

    /**
     * Get list of data point groups
     */

    getGroups: ({state, getters, commit, dispatch}, force) => {

        if (force) commit('bustGroupCache');

        // Pull from store if loaded and cache hasn't expired
        if (state.groupsExpire && moment().isBefore(state.groupsExpire)) {
            return state.groups;
        }

        commit('setGroupsLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/data-variable-groups')

                .then(({data}) => {

                    commit('setGroups', data.dataVariableGroups);
                    commit('setGroupsLoading', false);
                    commit('setGroupsLoaded', true);
                    resolve(null);
                })
                .catch(error => {

                    commit('setGroupsLoading', false);
                    reject(error);
                });
        });
    },

    /**
     * Create data node group
     */

    createGroup: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.put('/data-variable-groups', data)

                .then((response: AxiosResponse) => {

                    commit('addGroup', response.data.dataVariableGroup);
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    reject(error);
                });
        });
    },

    /**
     * Update data point group
     */

    updateGroup: ({state, getters, commit, dispatch}, data) => {

        // Clone original
        const backup = Object.assign({}, state.groups.find((group: DataVariableInterface) => group.id === data.id));

        commit('updateGroup', data);

        return new Promise((resolve, reject) => {

            axios.post('/data-variable-groups', data)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    // Restore original object
                    commit('updateGroup', backup);
                    reject(error);
                });
        });
    },

    /**
     * Update data point group
     */

    deleteGroup: ({state, getters, commit, dispatch}, id) => {

        // Clone original
        const groups = [...state.groups];

        commit('deleteGroup', id);

        return new Promise((resolve, reject) => {

            axios.delete('/data-variable-groups/' + id)

                .then((response: AxiosResponse) => {
                    resolve(response);
                })
                .catch((error: AxiosError) => {
                    // Restore original object
                    commit('setGroups', groups);
                    reject(error);
                });
        });
    },
    /**
     * Assign data point to a group
     */
    assignToGroup: ({state, getters, commit, dispatch, rootState}, {group, dataVariables}) => {

        // Clone original
        const dataVariablesOriginal = [...rootState.dataVariables];

        return new Promise((resolve, reject) => {

            try {
                commit('assignToGroup', {dataVariables: dataVariables, groupId: group.id});

                commit('updateDataVariableGroups', {dataVariables: dataVariables, group: group}, {root: true});

                // Extract IDs for the post
                let dataVariableIds: Array<number> = [];

                dataVariables.forEach((dataVariable: DataVariable) => {
                    dataVariableIds.push(dataVariable.id);
                });

                axios.post('/data-variable-groups/' + group.id + '/assign', {dataVariableIds: dataVariableIds})

                    .then((response: AxiosResponse) => {
                        resolve(response);
                    })
                    .catch((error: AxiosError) => {
                        commit('setDataVariables', dataVariablesOriginal, {root: true});
                        reject(error);
                    });

            } catch (e) {
                reject(e);
            }
        });
    },

    /**
     * Get list of data point groups
     */
    getRangeStats: ({state, getters, commit, dispatch}, data) => {

        return new Promise((resolve, reject) => {

            axios.post('/data-variable/' + data.dataVariableId + '/range-stats', data)

                .then((response) => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * Get list of standard data variables
     */
    getStandardVariables: ({state, getters, commit, dispatch}) => {

        return new Promise((resolve, reject) => {

            axios.get('/data-variables/standard')

                .then((response) => {

                    commit('setStandardVariables', response.data.variables);

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    /**
     * Create standard variables
     */
    createStandardVariable: ({state, getters, commit, dispatch}, name) => {

        return new Promise((resolve, reject) => {

            axios.post('/data-variables/standard', {name: name})

                .then((response) => {

                    commit('addDataVariable', response.data.variable, {root: true});

                    resolve(response);
                })
                .catch(error => {

                    reject(error);
                });
        });
    },
}
